import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './auth.css';
import misc from '../../misc';

export class Login extends Component {
  renderStateMessage() {
    const { location } = this.props;
    if (!location.state || !location.state.message) {
      return;
    }
    if (!location.state.messageClassSuffix) {
      location.state.messageClassSuffix = 'primary';
    }
    const { message, messageClassSuffix } = location.state;
    return (
      <misc.components.Alert class={messageClassSuffix} message={message} />
    );
  }

  render() {
    const { error, handleSubmit, pristine, submitting } = this.props;

    return (
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <form onSubmit={handleSubmit(this.props.onSubmit)}>
              <div className="text-center m-4">
                <img
                  src={misc.images.logoGrey3}
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="Federation"
                />
                <h2 className="mb-1 d-inline-block align-bottom">
                  &nbsp;Login
                </h2>
              </div>
              {this.renderStateMessage()}
              {this.props.isError && (
                <misc.components.Alert message={this.props.errorMessage} />
              )}

              {/*
              <a href="/api/auth/google" className="btn btn-lg btn-primary btn-block">
                <span className="icon icon-google-plus" /> Login with Google
              </a>
              <div className="text-center m-4">
                &mdash; <em>or</em> &mdash;
              </div>
              */}

              {error && <misc.components.Alert message={error} />}
              <Field
                component={misc.components.FormField}
                name="email"
                id="email"
                type="email"
                label="Email"
                required
                autoFocus
              />
              <Field
                component={misc.components.FormField}
                name="password"
                id="password"
                type="password"
                label="Password"
                required
              />
              <misc.components.LoadingButton
                className="btn-lg"
                disabled={pristine || submitting}
                loading={this.props.isLoading}
              >
                Login
              </misc.components.LoadingButton>
              <div className="text-center m-3">
                Don't have an account yet?&nbsp;
                <Link to="/auth/signup">Sign up here</Link>
              </div>
              <div className="text-center m-4">
                <Link to="/auth/forgotPassword">Forgotten your password?</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  location: PropTypes.object
};

Login.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export function validate(values) {
  const errors = {};

  // Email
  if (!values.get('email')) {
    errors.email = true;
  }

  // Password
  if (!values.get('password')) {
    errors.password = true;
  }

  return errors;
}

export default reduxForm({
  validate,
  form: 'loginForm'
})(Login);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Login.js